import { render, staticRenderFns } from "./AdditionalService.vue?vue&type=template&id=6d97ffe8&scoped=true&"
import script from "./AdditionalService.vue?vue&type=script&lang=js&"
export * from "./AdditionalService.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalService.vue?vue&type=style&index=0&id=6d97ffe8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d97ffe8",
  null
  
)

export default component.exports